<ng-form class="k-form k-form-md" [formGroup]="armForm">
    <fieldset>
        <legend style="border-bottom: 1px solid #e2e8f0;">DHT Arm Parameters</legend>
        <div class="row">
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="ArmSize">Tooling Size</kendo-label>
                    <kendo-dropdownlist formControlName="size" id="ArmSize" name="ArmSize"
                        [data]="sizeOptions" textField="label" valueField="value"
                        [valuePrimitive]="true" [readonly]="readonly">
                    </kendo-dropdownlist>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="ArmType">Type</kendo-label>
                    <kendo-textbox formControlName="type" id="ArmType" name="ArmType"
                        [readonly]="readonly"></kendo-textbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-3">
                <kendo-formfield>
                    <kendo-label for="ArmLevel">Level</kendo-label>
                    <kendo-dropdownlist formControlName="level" id="ArmLevel" name="ArmLevel"
                        [data]="levelOptions" textField="name" valueField="id"
                        [valuePrimitive]="true" [readonly]="readonly">
                    </kendo-dropdownlist>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="ArmGaugeLength">Gauge Length</kendo-label>
                    <kendo-numerictextbox formControlName="gaugeLength" id="ArmGaugeLength" name="ArmGaugeLength"
                        [decimals]="decimals" [format]="format" [min]="0" [step]="0.001"
                        [inputAttributes]="inputModeDecimal"
                        [readonly]="readonly" [spinners]="!readonly"></kendo-numerictextbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-3">
                <kendo-formfield>
                    <kendo-label for="ArmHardfacing">Hardfacing</kendo-label>
                    <kendo-dropdownlist formControlName="hardfacing" id="ArmHardfacing" name="ArmHardfacing"
                        textField="name" [valuePrimitive]="true" valueField="name"
                        [data]="hardfacingOptions$ | async"
                        [readonly]="readonly"></kendo-dropdownlist>
                </kendo-formfield>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="ArmOpeningSize">Opening Size (in)</kendo-label>
                    <kendo-numerictextbox formControlName="openingSize" id="ArmOpeningSize" name="ArmOpeningSize"
                        [decimals]="3" [format]="'n3'" [min]="0" [step]="0.001"
                        [inputAttributes]="inputModeDecimal"
                        [readonly]="readonly" [spinners]="!readonly"></kendo-numerictextbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="ArmCutterRow">Cutter Row</kendo-label>
                    <kendo-numerictextbox formControlName="cutterRow" id="ArmCutterRow" name="ArmCutterRow"
                        [decimals]="0" [format]="'n0'" [min]="0" [step]="1"
                        [readonly]="readonly" [spinners]="!readonly"></kendo-numerictextbox>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-2">
                <kendo-formfield>
                    <kendo-label for="ArmNewArm">New Arm</kendo-label>
                    <div style="padding-top: 4px;">
                        <kendo-switch formControlName="newArm" id="ArmNewArm" name="ArmNewArm"
                            [readonly]="readonly"></kendo-switch>
                    </div>
                </kendo-formfield>
            </div>
        </div>
    </fieldset>
</ng-form>
